import React from "react";

import { LabelField } from "components";
import { formatDate } from "helper/dateFormat";
import { mailTo, phoneTo } from "utils/contactTo";
import CopyButton from "components/CopyButton/CopyButton";
import { formatPhoneNumber } from "react-phone-number-input";

const fieldWrapperClass =
  "form-control form-control-solid h-auto py-5 px-6 position-relative";

const ProfileView = ({ member }) => {
  const email = member?.email_address;
  const phone = formatPhoneNumber(member?.mobile_number || "");
  const dob = member?.date_of_birth
    ? formatDate({ date: member.date_of_birth, formatType: "defaultWithUTC" })
    : "DOB";
  const gender = member?.gender || "Sex";

  return (
    <>
      <LabelField className="mb-0 mt-5" title="Email" />
      <div className={fieldWrapperClass}>
        {email ? (
          <>
            <a className="account-details__field-link" href={mailTo({ email })}>
              {email}
            </a>
            <CopyButton value={email} />
          </>
        ) : (
          "Email"
        )}
      </div>

      <LabelField className="mb-0 mt-5" title="Phone number" />
      <div className={fieldWrapperClass}>
        {member?.mobile_number ? (
          <>
            <a
              className="account-details__field-link"
              href={phoneTo({ phone })}
            >
              {phone}
            </a>
            <CopyButton value={phone} />
          </>
        ) : (
          "Phone number"
        )}
      </div>

      <LabelField className="mb-0 mt-5" title="Date of birth" />
      <div className="form-control form-control-solid h-auto py-5 px-6">
        {dob}
      </div>

      <LabelField className="mb-0 mt-5" title="Sex" />
      <div className="form-control form-control-solid h-auto py-5 px-6">
        {gender}
      </div>
    </>
  );
};

export default ProfileView;
